import React from "react";

export default function LockIcon({
	color = "#1a1c21",
	width = 21,
	height = 27,
}) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 21 27"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.8086 20.25C12.1836 20.25 13.3086 19.125 13.3086 17.75C13.3086 16.375 12.1836 15.25 10.8086 15.25C9.43359 15.25 8.30859 16.375 8.30859 17.75C8.30859 19.125 9.43359 20.25 10.8086 20.25ZM18.3086 9H17.0586V6.5C17.0586 3.05 14.2586 0.25 10.8086 0.25C7.35859 0.25 4.55859 3.05 4.55859 6.5V9H3.30859C1.93359 9 0.808594 10.125 0.808594 11.5V24C0.808594 25.375 1.93359 26.5 3.30859 26.5H18.3086C19.6836 26.5 20.8086 25.375 20.8086 24V11.5C20.8086 10.125 19.6836 9 18.3086 9ZM6.93359 6.5C6.93359 4.3625 8.67109 2.625 10.8086 2.625C12.9461 2.625 14.6836 4.3625 14.6836 6.5V9H6.93359V6.5ZM18.3086 24H3.30859V11.5H18.3086V24Z"
				fill={color}
			/>
		</svg>
	);
}
